//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
import {
  PeopleFilterFields,
  PersonApplicationFilterFields,
  PersonCertificationFilterFields,
  PersonCustomFieldFields,
  PersonNotesFilterFields,
  PersonRaceFilterFields,
  PersonTagFilterFields,
  PersonTeamFilterFields
} from 'src/app/people/models/peopleFilterFields';
import { TeamRostersReportFields } from 'src/app/reports/team-rosters-report/team-rosters-report-fields';
import { Gender } from 'src/app/shared/models/gender';
import { ChildFieldsFilterModel } from 'src/app/shared/odata-filter-models/child-fields-filter-model';
import { ODataFilterBuilder } from 'src/app/shared/odata-filter-models/odata-filter-builder';
import { RegularFilterModel } from 'src/app/shared/odata-filter-models/regular-filter-model';
import { PersonStatus } from 'src/app/people/models/personStatus';
import { SeatStatus } from 'src/app/shared/models/team/seatStatus';
import { TeamRegularFields } from 'src/app/teams/teams-home/team-regular-fields';
import { ODataFilterValues } from './odata-filter';
import { SearchValueType } from './search-value-type';
import { FilterOperatorType } from './filter-operator-type';
import { TeamSurveyDetailsReportFields } from 'src/app/reports/team-survey-details-report/team-survey-details-report.fields';
import { SurveyStatus } from 'src/app/shared/models/survey/surveyStatus';
import { FormDetailsReportFields } from 'src/app/reports/form-details-report/form-details-report.fields';
import { FormStatus } from 'src/app/shared/models/application/formStatus';
import { SearchBoxFilterModel } from 'src/app/shared/odata-filter-models/search-box-filter-model';
import { AttributeUiType } from 'src/app/shared/models/attributes/attributeUiType';
import { SingleWorkspaceFilterModel } from 'src/app/shared/odata-filter-models/single-workspace-filter-model';
import { SubConditionFilterModel } from 'src/app/shared/odata-filter-models/sub-condition-filter-model';
import { OpportunityBoardFilterFields } from 'src/app/public/opportunities/opportunities/models/opportunityBoardFilterFields';
import {
  CredentialingDetailsReportFields,
  CredentialTagFilterFields
} from 'src/app/reports/credentialing-details-report/credentialing-details-report.fields';
import { PaymentRecordsReportFields } from 'src/app/reports/payment-records-report/payment-records-report.fields';
import { AllInvoiceReportFields } from 'src/app/reports/all-invoice-report/all-invoice-report.fields';
import { CredentialApplicationDefinitionType } from 'src/app/shared/models/credential/CredentialApplicationDefinitionType';
import { OpportunityBoardReportFields } from 'src/app/reports/opportunity-board-report/opportunity-board-report-fields';
import { TeamEvaluationDetailsReportFields } from 'src/app/reports/team-evaluation-details-report/team-evaluation-details-report.fields';
import { InvoiceStatus } from 'src/shared-app-portal/components/profile-payments/invoice-model';
import { CredentialStatus } from 'src/app/shared/models/credential/credentialStatus';
import {
  CredentialScenarioReportFields,
  CredentialScenarioTagFilterFields
} from 'src/app/reports/credential-scenario-report/credential-scenario-report.fields';
import { InProgressEntityCredentialApplicationFields } from 'src/app/credentialing/credentialing-home/inprogress_entity_credential-application.fields';
import { BaseCredentialApplicationReportFields } from '../../credential-application-report/base-credential-application-report.fields';
import { PersonCredentialApplicationReportFields } from '../../credential-application-report/person-credential-application-report.fields';
import { TeamCredentialApplicationReportFields } from '../../credential-application-report/team-credential-application-report.fields';

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const TEAM_SYSTEM_FILTER_MODELS = {
  TeamIdFilterModel: new RegularFilterModel('Team Id', TeamRegularFields.id, SearchValueType.Guid),
  TeamStatusFilterModel: new RegularFilterModel(
    'Team Status',
    TeamRegularFields.status,
    SearchValueType.List,
    ['Active', 'Archived']
  ),
  TeamNameFilterModel: new RegularFilterModel(
    'Team Name',
    TeamRegularFields.name,
    SearchValueType.String
  ),
  TeamStartDateFilterModel: new RegularFilterModel(
    'Team Start Date',
    TeamRegularFields.startDate,
    SearchValueType.Date
  ),
  TeamEndDateFilterModel: new RegularFilterModel(
    'Team End Date',
    TeamRegularFields.endDate,
    SearchValueType.Date
  ),
  TeamWorkspaceFilterModel: new SingleWorkspaceFilterModel(
    TeamRegularFields.workspaceId,
    'Workspace'
  ),
  TeamPublicNameFilterModel: new RegularFilterModel(
    'Public Name',
    TeamRegularFields.publicName,
    SearchValueType.String
  ),
  TeamCredentialFilterModel: new ChildFieldsFilterModel(
    TeamRegularFields.credentials,
    'Credentials',
    'credentialDefinitionId',
    SearchValueType.MultiValue,
    [],
    ODataFilterBuilder.buildSimpleFilter(
      'systemStatus',
      CredentialStatus.PreIssue,
      FilterOperatorType.ne
    )
  ),
  ActiveTeamMemberCredentialViewFilterModel: new ChildFieldsFilterModel(
    TeamRegularFields.teamMemberCredentials,
    'Active Member Credentials',
    'credentialDefinitionId',
    SearchValueType.MultiValue,
    [],
    ODataFilterBuilder.buildArrayFilter(
      'credentialSystemStatus',
      [CredentialStatus.Active, CredentialStatus.ActiveRenewalPeriod],
      FilterOperatorType.in
    )
  ),
  TeamMemberCredentialViewFilterModel: new ChildFieldsFilterModel(
    TeamRegularFields.teamMemberCredentials,
    'Member Credentials',
    'credentialDefinitionId',
    SearchValueType.MultiValue,
    []
  ),
  TeamCityFilterModel: new RegularFilterModel(
    'City',
    TeamRegularFields.city,
    SearchValueType.String
  ),
  TeamStateFilterModel: new RegularFilterModel(
    'State',
    TeamRegularFields.state,
    SearchValueType.MultiValue
  ),
  TeamCountyFilterModel: new RegularFilterModel(
    'County',
    TeamRegularFields.county,
    SearchValueType.String,
    null,
    true
  ),
  TeamCountryFilterModel: new RegularFilterModel(
    'Country',
    TeamRegularFields.country,
    SearchValueType.MultiValue
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const TEAM_CREDENTIALS_SUB_FILTER_MODELS = {
  IssueDateFilterModel: new SubConditionFilterModel(
    'Issue Date',
    CredentialingDetailsReportFields.issueDate,
    SearchValueType.Date
  ),
  ExpirationDateFilterModel: new SubConditionFilterModel(
    'Expiration Date',
    CredentialingDetailsReportFields.expirationDate,
    SearchValueType.Date
  ),
  CredentialStatusFilterModel: new SubConditionFilterModel(
    'Credential Status',
    CredentialingDetailsReportFields.systemStatus,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues(CredentialStatus.Active, 'Active'),
      new ODataFilterValues(CredentialStatus.ActiveRenewalPeriod, 'Active Renewal Period'),
      new ODataFilterValues(CredentialStatus.Inactive, 'Inactive'),
      new ODataFilterValues(CredentialStatus.InactiveRenewalPeriod, 'Inactive Renewal Period'),
      new ODataFilterValues(CredentialStatus.Manual, 'Manual')
    ]
  ),
  CredentialNumberFilterModel: new SubConditionFilterModel(
    'Credential Number',
    CredentialingDetailsReportFields.credentialNumber,
    SearchValueType.String
  ),
  CredentialSpecialtyFilterModel: new SubConditionFilterModel(
    'Specialty',
    CredentialingDetailsReportFields.specialties,
    SearchValueType.MultiValue
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const TEAM_MEMBER_CREDENTIALS_SUB_FILTER_MODELS = {
  PersonFullNameFilterModel: new SubConditionFilterModel(
    'Full Name',
    'fullName',
    SearchValueType.String
  ),
  PersonEmailFilterModel: new SubConditionFilterModel('Email', 'email', SearchValueType.Email),
  CredentialNumberFilterModel: new SubConditionFilterModel(
    'Credential Number',
    'credentialNumber',
    SearchValueType.String
  ),
  CredentialStatusFilterModel: new SubConditionFilterModel(
    'Credential Status',
    'credentialSystemStatus',
    SearchValueType.MultiValue,
    [
      new ODataFilterValues(CredentialStatus.Active, 'Active'),
      new ODataFilterValues(CredentialStatus.ActiveRenewalPeriod, 'Active Renewal Period'),
      new ODataFilterValues(CredentialStatus.Inactive, 'Inactive'),
      new ODataFilterValues(CredentialStatus.InactiveRenewalPeriod, 'Inactive Renewal Period'),
      new ODataFilterValues(CredentialStatus.Manual, 'Manual')
    ]
  ),
  IssueDateFilterModel: new SubConditionFilterModel(
    'Credential Issue Date',
    'credentialIssueDate',
    SearchValueType.Date
  ),
  ExpirationDateFilterModel: new SubConditionFilterModel(
    'Credential Expiration Date',
    'credentialExpirationDate',
    SearchValueType.Date
  ),
  CredentialSpecialtyFilterModel: new SubConditionFilterModel(
    'Specialty',
    CredentialingDetailsReportFields.specialties,
    SearchValueType.MultiValue
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const TEAM_ROSTERS_REPORT_FILTER_MODELS = {
  TeamIdFilterModel: new RegularFilterModel(
    'Team Id',
    TeamRostersReportFields.teamId,
    SearchValueType.Guid
  ),
  TeamNameFilterModel: new RegularFilterModel(
    'Team Name',
    TeamRostersReportFields.teamName,
    SearchValueType.String
  ),
  TeamPublicNameFilterModel: new RegularFilterModel(
    'Team Public Name',
    TeamRostersReportFields.teamPublicName,
    SearchValueType.String
  ),
  TeamStatusFilterModel: new RegularFilterModel(
    'Team Status',
    TeamRostersReportFields.teamStatus,
    SearchValueType.List,
    ['Active', 'Archived']
  ),
  TeamStartDateFilterModel: new RegularFilterModel(
    'Team Start Date',
    TeamRostersReportFields.teamStartDate,
    SearchValueType.Date
  ),
  TeamEndDateFilterModel: new RegularFilterModel(
    'Team End Date',
    TeamRostersReportFields.teamEndDate,
    SearchValueType.Date
  ),
  PersonNameFilterModel: new RegularFilterModel(
    'Person Name',
    TeamRostersReportFields.personName,
    SearchValueType.String
  ),
  PersonEmailFilterModel: new RegularFilterModel(
    'Person Email',
    TeamRostersReportFields.personEmail,
    SearchValueType.Email
  ),
  PersonCompayFilterModel: new RegularFilterModel(
    'Person Company',
    TeamRostersReportFields.personCompany,
    SearchValueType.String
  ),
  PersonCertMetricsCandidateIdFilterModel: new RegularFilterModel(
    'Person CertMetrics Candidate Id',
    TeamRostersReportFields.personCandidateId,
    SearchValueType.String
  ),
  PersonJobTitleFilterModel: new RegularFilterModel(
    'Person Job Title',
    TeamRostersReportFields.personJobTitle,
    SearchValueType.String
  ),
  ProfileStatusFilterModel: new RegularFilterModel(
    'Profile Status',
    TeamRostersReportFields.personStatus,
    SearchValueType.List,
    [PersonStatus.Active, PersonStatus.Archived, PersonStatus.Potential]
  ),
  PositionName: new RegularFilterModel(
    'Position Name',
    TeamRostersReportFields.positionTitle,
    SearchValueType.String
  ),
  PositionStatusFilterModel: new RegularFilterModel(
    'Position Status',
    TeamRostersReportFields.seatStatus,
    SearchValueType.List,
    [
      SeatStatus[SeatStatus.Picked],
      SeatStatus[SeatStatus.Invited],
      SeatStatus[SeatStatus.NoResponse],
      SeatStatus[SeatStatus.Accepted],
      SeatStatus[SeatStatus.Declined],
      SeatStatus[SeatStatus.NoShow]
    ]
  ),
  PositionUpdateDateFilterModel: new RegularFilterModel(
    'Position Update Date',
    TeamRostersReportFields.seatUpdatedOn,
    SearchValueType.Date
  ),
  SeatStartDateFilterModel: new RegularFilterModel(
    'Seat Start Date',
    TeamRostersReportFields.seatStartDate,
    SearchValueType.Date
  ),
  SeatEndDateFilterModel: new RegularFilterModel(
    'Seat End Date',
    TeamRostersReportFields.seatEndDate,
    SearchValueType.Date
  ),
  PersonEmailPreferenceFilterModel: new RegularFilterModel(
    'Person Email Preference',
    TeamRostersReportFields.personIsUnsubscribed,
    SearchValueType.Boolean,
    [new ODataFilterValues(true, 'UnSubscribed'), new ODataFilterValues(false, 'Subscribed')]
  ),
  ExpressedInterestDateFilterModel: new RegularFilterModel(
    'Expressed Interest',
    TeamRostersReportFields.seatUpdatedOn,
    SearchValueType.Date
  ),
  SkillsFilterModel: new ChildFieldsFilterModel(
    TeamRostersReportFields.personCustomFields,
    'Skills',
    'id',
    SearchValueType.MultiValue,
    []
  ),
  PersonGenderFilterModel: new RegularFilterModel(
    'Gender',
    TeamRostersReportFields.gender,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues(Gender.Female, Gender.Female),
      new ODataFilterValues(Gender.Male, Gender.Male),
      new ODataFilterValues(Gender.Male, Gender.Male),
      new ODataFilterValues(Gender.NonBinary, Gender.NonBinary),
      new ODataFilterValues(Gender.PreferNotToAnswer, Gender.PreferNotToAnswer)
    ]
  ),
  PersonRaceFilterModel: new ChildFieldsFilterModel(
    TeamRostersReportFields.races,
    'Race',
    PersonRaceFilterFields.id,
    SearchValueType.MultiValue
  ),
  PersonCountryFilterModel: new RegularFilterModel(
    'Country',
    TeamRostersReportFields.country,
    SearchValueType.MultiValue
  ),
  PersonStateFilterModel: new RegularFilterModel(
    'State',
    TeamRostersReportFields.state,
    SearchValueType.MultiValue
  ),
  PersonTagFilterModel: new ChildFieldsFilterModel(
    TeamRostersReportFields.personTags,
    'Person Tag',
    PersonTagFilterFields.text,
    SearchValueType.MultiValue
  ),
  TeamWorkspaceFilterModel: new SingleWorkspaceFilterModel(
    TeamRostersReportFields.teamWorkspaceId,
    'Team Workspace'
  ),
  PersonExternalSystemIdFilterModel: new RegularFilterModel(
    'Person External System Id',
    TeamRostersReportFields.personExternalSystemId,
    SearchValueType.String
  ),
  ActivePersonCertificationFilterModel: new ChildFieldsFilterModel(
    TeamRostersReportFields.personCertifications,
    'Active Person Certification',
    PersonCertificationFilterFields.certificationId,
    SearchValueType.MultiValue,
    [],
    ODataFilterBuilder.buildDateIsNotExpiredFilter(PersonCertificationFilterFields.expirationDate)
  ),
  PersonCertificationsFilterModel: new ChildFieldsFilterModel(
    TeamRostersReportFields.personCertifications,
    'Person Certifications',
    PersonCertificationFilterFields.certificationId,
    SearchValueType.MultiValue,
    []
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const OPPORTUNITY_BOARD_REPORT_FILTER_MODELS = {
  SearchFilterModel: new SearchBoxFilterModel([
    { name: OpportunityBoardReportFields.fullName, isGuid: false, isEmail: false },
    { name: OpportunityBoardReportFields.teamName, isGuid: false, isEmail: false }
  ]),
  TeamNameFilterModel: new RegularFilterModel(
    'Team Name',
    OpportunityBoardReportFields.teamName,
    SearchValueType.MultiValue,
    []
  ),
  FirstNameFilterModel: new RegularFilterModel(
    'First Name',
    OpportunityBoardReportFields.firstName,
    SearchValueType.String
  ),
  LastNameFilterModel: new RegularFilterModel(
    'Last Name',
    OpportunityBoardReportFields.lastName,
    SearchValueType.String
  ),
  FullNameFilterModel: new RegularFilterModel(
    'Full Name',
    OpportunityBoardReportFields.fullName,
    SearchValueType.String
  ),
  EmailFilterModel: new RegularFilterModel(
    'Email',
    OpportunityBoardReportFields.email,
    SearchValueType.Email
  ),
  OpportunityBoardFilterModel: new RegularFilterModel(
    'Opportunity Board',
    OpportunityBoardReportFields.opportunityBoardName,
    SearchValueType.String
  ),
  Position: new RegularFilterModel(
    'Position',
    OpportunityBoardReportFields.position,
    SearchValueType.String
  ),
  CurrentStatusFilterModel: new RegularFilterModel(
    'Current Status',
    OpportunityBoardReportFields.currentStatus,
    SearchValueType.List,
    [
      SeatStatus[SeatStatus.Picked],
      SeatStatus[SeatStatus.Invited],
      SeatStatus[SeatStatus.NoResponse],
      SeatStatus[SeatStatus.Accepted],
      SeatStatus[SeatStatus.Declined],
      SeatStatus[SeatStatus.NoShow],
      SeatStatus[SeatStatus.Bench]
    ]
  ),
  StartDateFilterModel: new RegularFilterModel(
    'Start Date',
    OpportunityBoardReportFields.seatStartDate,
    SearchValueType.Date
  ),
  EndDateFilterModel: new RegularFilterModel(
    'End Date',
    OpportunityBoardReportFields.seatEndDate,
    SearchValueType.Date
  ),
  DateExpressedInterestFilterModel: new RegularFilterModel(
    'Date Expressed Interest',
    OpportunityBoardReportFields.dateExpressedInterest,
    SearchValueType.Date
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const PEOPLE_FILTER_MODELS = {
  SearchFilterModel: new SearchBoxFilterModel(
    [
      { name: PeopleFilterFields.email, isGuid: false, isEmail: true },
      { name: PeopleFilterFields.id, isGuid: true, isEmail: false },
      { name: PeopleFilterFields.textSearch, isGuid: false, isEmail: false }
    ],
    true
  ),
  StatusFilterModel: new RegularFilterModel(
    'Profile Status',
    PeopleFilterFields.status,
    SearchValueType.List,
    [PersonStatus.Active, PersonStatus.Archived, PersonStatus.Potential]
  ),
  FirstNameFilterModel: new RegularFilterModel(
    'First Name',
    PeopleFilterFields.firstName,
    SearchValueType.String,
    null,
    true
  ),
  LastNameFilterModel: new RegularFilterModel(
    'Last Name',
    PeopleFilterFields.lastName,
    SearchValueType.String,
    null,
    true
  ),
  FullNameFilterModel: new RegularFilterModel(
    'Full Name',
    PeopleFilterFields.fullName,
    SearchValueType.String,
    null,
    true
  ),
  EmailFilterModel: new RegularFilterModel(
    'Email',
    PeopleFilterFields.email,
    SearchValueType.Email
  ),
  RatingFilterModel: new RegularFilterModel(
    'Evaluation Rating',
    PeopleFilterFields.rating,
    SearchValueType.Number
  ),
  EmailPreferenceFilterModel: new RegularFilterModel(
    'Email Preference',
    PeopleFilterFields.isUnsubscribed,
    SearchValueType.Boolean,
    [new ODataFilterValues(true, 'UnSubscribed'), new ODataFilterValues(false, 'Subscribed')]
  ),
  GenderFilterModel: new RegularFilterModel(
    'Gender',
    PeopleFilterFields.gender,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues(Gender.Female, Gender.Female),
      new ODataFilterValues(Gender.Male, Gender.Male),
      new ODataFilterValues(Gender.Male, Gender.Male),
      new ODataFilterValues(Gender.NonBinary, Gender.NonBinary),
      new ODataFilterValues(Gender.PreferNotToAnswer, Gender.PreferNotToAnswer)
    ]
  ),
  PhoneFilterModel: new RegularFilterModel(
    'Phone Number',
    PeopleFilterFields.phoneNumberSearch,
    SearchValueType.PhoneNumber
  ),
  RaceFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.races,
    'Race',
    PersonRaceFilterFields.id,
    SearchValueType.MultiValue
  ),
  ActiveTeamsCountFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.activeTeamSummary,
    'Active Teams Count',
    PeopleFilterFields.activeTeamsCount,
    SearchValueType.Number
  ),
  AllTeamsCountFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.allTeamSummary,
    'All Teams Count',
    PeopleFilterFields.allTeamsCount,
    SearchValueType.Number
  ),
  CreatedOnFilterModel: new RegularFilterModel(
    'Created Date',
    PeopleFilterFields.createdOn,
    SearchValueType.Date
  ),
  UpdatedOnFilterModel: new RegularFilterModel(
    'Last Updated Date',
    PeopleFilterFields.updatedOn,
    SearchValueType.Date
  ),
  CityFilterModel: new RegularFilterModel('City', PeopleFilterFields.city, SearchValueType.String),
  ProvinceFilterModel: new RegularFilterModel(
    'Province',
    PeopleFilterFields.province,
    SearchValueType.String
  ),
  CountryFilterModel: new RegularFilterModel(
    'Country',
    PeopleFilterFields.country,
    SearchValueType.MultiValue
  ),
  CountyFilterModel: new RegularFilterModel(
    'County',
    PeopleFilterFields.county,
    SearchValueType.String,
    null,
    true
  ),
  StateFilterModel: new RegularFilterModel(
    'State',
    PeopleFilterFields.state,
    SearchValueType.MultiValue
  ),
  TagFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.tags,
    'Tag',
    PersonTagFilterFields.text,
    SearchValueType.MultiValue
  ),
  NotesFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.notes,
    'Notes',
    PersonNotesFilterFields.description,
    SearchValueType.String
  ),
  SubmittedApplicationFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.applications,
    'Submitted Lineup Forms',
    PersonApplicationFilterFields.formId,
    SearchValueType.MultiValue,
    [],
    ODataFilterBuilder.buildSimpleFilter(PersonApplicationFilterFields.isUsed, true)
  ),
  LineupFormsFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.applications,
    'Lineup Forms',
    PersonApplicationFilterFields.formId,
    SearchValueType.MultiValue,
    []
  ),
  ActiveCertificationFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.certifications,
    'Active Certification',
    PersonCertificationFilterFields.certificationId,
    SearchValueType.MultiValue,
    [],
    ODataFilterBuilder.buildDateIsNotExpiredFilter(PersonCertificationFilterFields.expirationDate)
  ),
  CertificationsFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.certifications,
    'Certifications',
    PersonCertificationFilterFields.certificationId,
    SearchValueType.MultiValue,
    []
  ),
  TeamExperienceFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.teams,
    'Team Experience',
    PersonTeamFilterFields.id,
    SearchValueType.MultiValue,
    [],
    ODataFilterBuilder.buildSimpleFilter(
      PersonTeamFilterFields.positionStatus,
      SeatStatus[SeatStatus.Declined],
      FilterOperatorType.ne
    )
  ),
  TeamHistoryFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.teams,
    'Team History',
    PersonTeamFilterFields.id,
    SearchValueType.MultiValue,
    []
  ),
  PositionStatusFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.teams,
    'Position Status in Active Team',
    PersonTeamFilterFields.positionStatus,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues(SeatStatus[SeatStatus.Accepted], SeatStatus[SeatStatus.Accepted]),
      new ODataFilterValues(SeatStatus[SeatStatus.Declined], SeatStatus[SeatStatus.Declined]),
      new ODataFilterValues(SeatStatus[SeatStatus.NoShow], SeatStatus[SeatStatus.NoShow]),
      new ODataFilterValues(SeatStatus[SeatStatus.Invited], SeatStatus[SeatStatus.Invited]),
      new ODataFilterValues(SeatStatus[SeatStatus.NoResponse], SeatStatus[SeatStatus.NoResponse]),
      new ODataFilterValues(SeatStatus[SeatStatus.Picked], SeatStatus[SeatStatus.Picked])
    ],
    ODataFilterBuilder.buildSimpleFilter(PersonTeamFilterFields.status, 'Active')
  ),
  CertMetricsCandidateIdFilterModel: new RegularFilterModel(
    'CertMetrics Candidate Id',
    PeopleFilterFields.candidateId,
    SearchValueType.String
  ),
  SkillsFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.customFields,
    'Skills',
    PersonCustomFieldFields.id,
    SearchValueType.Skill,
    [],
    ODataFilterBuilder.buildSimpleFilter(PersonCustomFieldFields.uiType, AttributeUiType.Skill)
  ),
  JobTitleFilterModel: new RegularFilterModel(
    'Job Title',
    PeopleFilterFields.jobTitle,
    SearchValueType.String
  ),
  CompanyFilterModel: new RegularFilterModel(
    'Company',
    PeopleFilterFields.company,
    SearchValueType.String
  ),
  WorkspaceFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.workspaces,
    'Workspace',
    'workspaceId',
    SearchValueType.WorkspaceMultiValue
  ),
  LinkedInFilterModel: new RegularFilterModel(
    'LinkedIn',
    PeopleFilterFields.linkedInProfile,
    SearchValueType.EmptyOperator
  ),
  ExternalSystemIdFilterModel: new RegularFilterModel(
    'External System Id',
    PeopleFilterFields.externalSystemId,
    SearchValueType.String
  ),
  PersonCredentialFilterModel: new ChildFieldsFilterModel(
    PeopleFilterFields.credentials,
    'Credentials',
    'credentialDefinitionId',
    SearchValueType.MultiValue,
    [],
    ODataFilterBuilder.buildSimpleFilter(
      'systemStatus',
      CredentialStatus.PreIssue,
      FilterOperatorType.ne
    )
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const TEAM_SURVEY_SYSTEM_FILTER_MODELS = {
  SurveyTemplateIdFilterModel: new RegularFilterModel(
    'Template Id',
    TeamSurveyDetailsReportFields.templateId,
    SearchValueType.Guid
  ),
  SurveySentDateFilterModel: new RegularFilterModel(
    'Sent Date',
    TeamSurveyDetailsReportFields.sentDate,
    SearchValueType.Date
  ),
  SurveySubmissionDateFilterModel: new RegularFilterModel(
    'Submission Date',
    TeamSurveyDetailsReportFields.submissionDate,
    SearchValueType.Date
  ),
  SurveyStatusFilterModel: new RegularFilterModel(
    'Survey Status',
    TeamSurveyDetailsReportFields.surveyStatus,
    SearchValueType.List,
    [SurveyStatus.ReadyToComplete, SurveyStatus.Complete, SurveyStatus.Expired]
  ),
  TeamNameFilterModel: new RegularFilterModel(
    'Team Name',
    TeamSurveyDetailsReportFields.teamId,
    SearchValueType.MultiValue,
    []
  ),
  TeamStartDateFilterModel: new RegularFilterModel(
    'Team Start Date',
    TeamSurveyDetailsReportFields.teamStartDate,
    SearchValueType.Date
  ),
  TeamEndDateFilterModel: new RegularFilterModel(
    'Team End Date',
    TeamSurveyDetailsReportFields.teamEndDate,
    SearchValueType.Date
  ),
  PersonIdFilterModel: new RegularFilterModel(
    'PersonId',
    TeamSurveyDetailsReportFields.personId,
    SearchValueType.Guid
  ),
  FirstNameFilterModel: new RegularFilterModel(
    'First Name',
    TeamSurveyDetailsReportFields.firstName,
    SearchValueType.String
  ),
  LastNameFilterModel: new RegularFilterModel(
    'Last Name',
    TeamSurveyDetailsReportFields.lastName,
    SearchValueType.String
  ),
  EmailFilterModel: new RegularFilterModel(
    'Email',
    TeamSurveyDetailsReportFields.email,
    SearchValueType.String
  ),
  IsAnonymousFilterModel: new RegularFilterModel(
    'Survey Anonymity',
    TeamSurveyDetailsReportFields.isAnonymous,
    SearchValueType.Boolean,
    [new ODataFilterValues(true, 'Anonymous'), new ODataFilterValues(false, 'Not Anonymous')]
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const EVALUATION_SYSTEM_FILTER_MODELS = {
  EvaluationNameFilterModel: new RegularFilterModel(
    'Evaluation Name',
    TeamEvaluationDetailsReportFields.evaluationName,
    SearchValueType.String
  ),
  EvaluationExternalSystemIdFilterModel: new RegularFilterModel(
    'External System Id',
    TeamEvaluationDetailsReportFields.externalSystemId,
    SearchValueType.Guid
  ),
  EvaluateeFullNameFilterModel: new RegularFilterModel(
    'Full Name',
    TeamEvaluationDetailsReportFields.evaluateeFullName,
    SearchValueType.String
  ),
  EvaluateeFirstNameFilterModel: new RegularFilterModel(
    'First Name',
    TeamEvaluationDetailsReportFields.evaluateeFirstName,
    SearchValueType.String
  ),
  EvaluateeLastNameFilterModel: new RegularFilterModel(
    'Last Name',
    TeamEvaluationDetailsReportFields.evaluateeLastName,
    SearchValueType.String
  ),
  EvaluateeEmailFilterModel: new RegularFilterModel(
    'Email',
    TeamEvaluationDetailsReportFields.evaluateeEmail,
    SearchValueType.String
  ),
  EvaluateePositionFilterModel: new RegularFilterModel(
    'Position',
    TeamEvaluationDetailsReportFields.evaluateePosition,
    SearchValueType.String
  ),
  TeamNameFilterModel: new RegularFilterModel(
    'Team Name',
    TeamEvaluationDetailsReportFields.teamId,
    SearchValueType.MultiValue,
    []
  ),
  TeamStartDateFilterModel: new RegularFilterModel(
    'Team Start Date',
    TeamEvaluationDetailsReportFields.teamStartDate,
    SearchValueType.Date
  ),
  TeamEndDateFilterModel: new RegularFilterModel(
    'Team End Date',
    TeamEvaluationDetailsReportFields.teamEndDate,
    SearchValueType.Date
  ),
  SeatStartDateFilterModel: new RegularFilterModel(
    'Seat Start Date',
    TeamEvaluationDetailsReportFields.seatStartDate,
    SearchValueType.Date
  ),
  SeatEndDateFilterModel: new RegularFilterModel(
    'Seat End Date',
    TeamEvaluationDetailsReportFields.seatEndDate,
    SearchValueType.Date
  ),
  SearchFilterModel: new SearchBoxFilterModel([
    { name: TeamEvaluationDetailsReportFields.teamName, isGuid: false, isEmail: false },
    { name: TeamEvaluationDetailsReportFields.evaluateeEmail, isGuid: false, isEmail: true },
    { name: TeamEvaluationDetailsReportFields.evaluateeFirstName, isGuid: false, isEmail: false },
    { name: TeamEvaluationDetailsReportFields.evaluateeLastName, isGuid: false, isEmail: false },
    { name: TeamEvaluationDetailsReportFields.evaluationName, isGuid: false, isEmail: false }
  ])
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const FORM_SYSTEM_FILTER_MODELS = {
  SearchFilterModel: new SearchBoxFilterModel([
    { name: FormDetailsReportFields.respondentFullName, isGuid: false, isEmail: false },
    { name: FormDetailsReportFields.formName, isGuid: false, isEmail: false },
    { name: FormDetailsReportFields.respondentFirstNameAndLastName, isGuid: false, isEmail: false },
    { name: FormDetailsReportFields.respondentEmail, isGuid: false, isEmail: true }
  ]),
  FormIdFilterModel: new RegularFilterModel(
    'Form Id',
    FormDetailsReportFields.formId,
    SearchValueType.Guid
  ),
  PersonFullNameFilterModel: new RegularFilterModel(
    'Person Full Name',
    FormDetailsReportFields.respondentFullName,
    SearchValueType.String
  ),
  PersonFirstNameFilterModel: new RegularFilterModel(
    'Person First Name',
    FormDetailsReportFields.respondentFirstName,
    SearchValueType.String
  ),
  PersonLastNameFilterModel: new RegularFilterModel(
    'Person Last Name',
    FormDetailsReportFields.respondentLastName,
    SearchValueType.String
  ),
  PersonEmailFilterModel: new RegularFilterModel(
    'Person Email',
    FormDetailsReportFields.respondentEmail,
    SearchValueType.String
  ),
  PersonStatusFilterModel: new RegularFilterModel(
    'Person Status',
    FormDetailsReportFields.respondentStatus,
    SearchValueType.List,
    [PersonStatus.Active, PersonStatus.Archived, PersonStatus.Potential]
  ),
  TeamNameFilterModel: new RegularFilterModel(
    'Team Name',
    FormDetailsReportFields.teamName,
    SearchValueType.String
  ),
  SubmissionStatusFilterModel: new RegularFilterModel(
    'Submission Status',
    FormDetailsReportFields.formStatus,
    SearchValueType.List,
    [FormStatus.Submitted, FormStatus.NotSubmitted]
  ),
  FormSubmissionDateFilterModel: new RegularFilterModel(
    'Submission Date',
    FormDetailsReportFields.submissionDate,
    SearchValueType.Date
  ),
  FormSentDateFilterModel: new RegularFilterModel(
    'Sent Date',
    FormDetailsReportFields.sentDate,
    SearchValueType.Date
  ),
  SourceFilterModel: new RegularFilterModel(
    'Source',
    FormDetailsReportFields.source,
    SearchValueType.List,
    ['Sent invitation', 'Link request']
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const ACTIVE_CERTIFICATION_SUB_FILTER_MODELS = {
  CertificationNameFilterModel: new SubConditionFilterModel(
    'Certification Name',
    PersonCertificationFilterFields.name,
    SearchValueType.String
  ),
  CertificationNumberFilterModel: new SubConditionFilterModel(
    'Certification Number',
    PersonCertificationFilterFields.number,
    SearchValueType.String
  ),
  IssueDateFilterModel: new SubConditionFilterModel(
    'Issue Date',
    PersonCertificationFilterFields.activeDate,
    SearchValueType.Date
  ),
  ExpirationDateFilterModel: new SubConditionFilterModel(
    'Expiration Date',
    PersonCertificationFilterFields.expirationDate,
    SearchValueType.Date
  ),
  CertificationUrlFilterModel: new SubConditionFilterModel(
    'Certification URL',
    PersonCertificationFilterFields.url,
    SearchValueType.String
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const LINEUP_FORMS_SUB_FILTER_MODELS = {
  LineupFormNameFilterModel: new SubConditionFilterModel(
    'Lineup Form Name',
    PersonApplicationFilterFields.title,
    SearchValueType.String
  ),
  SubmissionStatusFilterModel: new SubConditionFilterModel(
    'Submission Status',
    PersonApplicationFilterFields.isUsed,
    SearchValueType.Boolean,
    [new ODataFilterValues(true, 'Submitted'), new ODataFilterValues(false, 'Not Submitted')]
  ),
  SentDateFilterModel: new SubConditionFilterModel(
    'Sent Date',
    PersonApplicationFilterFields.sentDate,
    SearchValueType.Date
  ),
  SubmissionDateFilterModel: new SubConditionFilterModel(
    'Submission Date',
    PersonApplicationFilterFields.submissionDate,
    SearchValueType.Date
  ),
  SourceFilterModel: new SubConditionFilterModel(
    'Source',
    PersonApplicationFilterFields.source,
    SearchValueType.List,
    ['Sent invitation', 'Link request']
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const TEAM_HISTORY_SUB_FILTER_MODELS = {
  TeamHistoryNameFilterModel: new SubConditionFilterModel(
    'Team Name',
    PersonTeamFilterFields.name,
    SearchValueType.String
  ),
  TeamHistoryStatusFilterModel: new SubConditionFilterModel(
    'Team Status',
    PersonTeamFilterFields.status,
    SearchValueType.List,
    ['Active', 'Archived']
  ),
  TeamHistoryPositionNameFilterModel: new SubConditionFilterModel(
    'Team Position Name',
    PersonTeamFilterFields.positionTitle,
    SearchValueType.String
  ),
  TeamHistoryPositionStatusFilterModel: new SubConditionFilterModel(
    'Position Status',
    PersonTeamFilterFields.positionStatus,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues(SeatStatus[SeatStatus.Accepted], SeatStatus[SeatStatus.Accepted]),
      new ODataFilterValues(SeatStatus[SeatStatus.Declined], SeatStatus[SeatStatus.Declined]),
      new ODataFilterValues(SeatStatus[SeatStatus.NoShow], SeatStatus[SeatStatus.NoShow]),
      new ODataFilterValues(SeatStatus[SeatStatus.Invited], SeatStatus[SeatStatus.Invited]),
      new ODataFilterValues(SeatStatus[SeatStatus.NoResponse], SeatStatus[SeatStatus.NoResponse]),
      new ODataFilterValues(SeatStatus[SeatStatus.Picked], SeatStatus[SeatStatus.Picked])
    ]
  ),
  SeatHistoryStartDateFilterModel: new SubConditionFilterModel(
    'Seat Start Date',
    PersonTeamFilterFields.seatStartDate,
    SearchValueType.Date
  ),
  SeatHistoryEndDateFilterModel: new SubConditionFilterModel(
    'Seat End Date',
    PersonTeamFilterFields.seatEndDate,
    SearchValueType.Date
  ),
  TeamHistoryStartDateFilterModel: new SubConditionFilterModel(
    'Team Start Date',
    PersonTeamFilterFields.teamStartDate,
    SearchValueType.Date
  ),
  TeamHistoryEndDateFilterModel: new SubConditionFilterModel(
    'Team End Date',
    PersonTeamFilterFields.teamEndDate,
    SearchValueType.Date
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const PERSON_SCENARIO_FILTER_MODELS = {
  FirstNameFilterModel: new RegularFilterModel(
    'First Name',
    CredentialScenarioReportFields.firstName,
    SearchValueType.String
  ),
  LastNameFilterModel: new RegularFilterModel(
    'Last Name',
    CredentialScenarioReportFields.lastName,
    SearchValueType.String
  ),
  EmailFilterModel: new RegularFilterModel(
    'Email',
    CredentialScenarioReportFields.email,
    SearchValueType.Email
  ),
  ApplicationNumberFilterModel: new RegularFilterModel(
    'Application Number',
    CredentialScenarioReportFields.credentialApplicationNumber,
    SearchValueType.String
  ),
  ApplicationStartDateFilterModel: new RegularFilterModel(
    'Application Start',
    CredentialScenarioReportFields.credentialApplicationStartDate,
    SearchValueType.Date
  ),
  ApplicationEndDateFilterModel: new RegularFilterModel(
    'Application End',
    CredentialScenarioReportFields.credentialApplicationEndDate,
    SearchValueType.Date
  ),
  ScenarioStatusFilterModel: new RegularFilterModel(
    'Status',
    CredentialScenarioReportFields.status,
    SearchValueType.List,
    ['InProgress', 'Completed']
  ),
  ApplicationTypeFilterModel: new RegularFilterModel(
    'Application Type',
    CredentialScenarioReportFields.credentialApplicationType,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues(CredentialApplicationDefinitionType.Initial, 'New Credential'),
      new ODataFilterValues(
        CredentialApplicationDefinitionType.Renewal,
        CredentialApplicationDefinitionType.Renewal
      ),
      new ODataFilterValues(
        CredentialApplicationDefinitionType.Reinstatement,
        CredentialApplicationDefinitionType.Reinstatement
      )
    ]
  ),
  TagFilterModel: new ChildFieldsFilterModel(
    CredentialScenarioReportFields.tags,
    'Tag',
    CredentialScenarioTagFilterFields.text,
    SearchValueType.MultiValue
  ),

  SearchFilterModel: new SearchBoxFilterModel([
    { name: CredentialScenarioReportFields.fullName, isGuid: false, isEmail: false },
    { name: CredentialScenarioReportFields.email, isGuid: false, isEmail: true }
  ])
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const TEAM_SCENARIO_FILTER_MODELS = {
  TeamNameFilterModel: new RegularFilterModel(
    'Team Name',
    CredentialScenarioReportFields.teamName,
    SearchValueType.String
  ),
  TeamPublicNameFilterModel: new RegularFilterModel(
    'Team Public Name',
    CredentialScenarioReportFields.teamPublicName,
    SearchValueType.String
  ),
  ApplicationNumberFilterModel: new RegularFilterModel(
    'Application Number',
    CredentialScenarioReportFields.credentialApplicationNumber,
    SearchValueType.String
  ),
  ApplicationStartDateFilterModel: new RegularFilterModel(
    'Application Start',
    CredentialScenarioReportFields.credentialApplicationStartDate,
    SearchValueType.Date
  ),
  ApplicationEndDateFilterModel: new RegularFilterModel(
    'Application End',
    CredentialScenarioReportFields.credentialApplicationEndDate,
    SearchValueType.Date
  ),
  ScenarioStatusFilterModel: new RegularFilterModel(
    'Status',
    CredentialScenarioReportFields.status,
    SearchValueType.List,
    ['InProgress', 'Completed']
  ),
  ApplicationTypeFilterModel: new RegularFilterModel(
    'Application Type',
    CredentialScenarioReportFields.credentialApplicationType,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues(CredentialApplicationDefinitionType.Initial, 'New Credential'),
      new ODataFilterValues(
        CredentialApplicationDefinitionType.Renewal,
        CredentialApplicationDefinitionType.Renewal
      ),
      new ODataFilterValues(
        CredentialApplicationDefinitionType.Reinstatement,
        CredentialApplicationDefinitionType.Reinstatement
      )
    ]
  ),
  TagFilterModel: new ChildFieldsFilterModel(
    CredentialScenarioReportFields.tags,
    'Tag',
    CredentialScenarioTagFilterFields.text,
    SearchValueType.MultiValue
  ),

  SearchFilterModel: new SearchBoxFilterModel([
    { name: CredentialScenarioReportFields.teamName, isGuid: false, isEmail: false },
    { name: CredentialScenarioReportFields.teamPublicName, isGuid: false, isEmail: false }
  ])
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
const BASE_CREDENTIAL_APPLICATION_FILTER_MODELS = {
  ApplicationTypeFilterModel: new RegularFilterModel(
    'Application Type',
    BaseCredentialApplicationReportFields.credentialApplicationType,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues(CredentialApplicationDefinitionType.Initial, 'New Credential'),
      new ODataFilterValues(
        CredentialApplicationDefinitionType.Renewal,
        CredentialApplicationDefinitionType.Renewal
      ),
      new ODataFilterValues(
        CredentialApplicationDefinitionType.Reinstatement,
        CredentialApplicationDefinitionType.Reinstatement
      )
    ]
  ),
  ApplicationNumberFilterModel: new RegularFilterModel(
    'Application Number',
    BaseCredentialApplicationReportFields.credentialApplicationNumber,
    SearchValueType.String
  ),
  ApplicationStartDateFilterModel: new RegularFilterModel(
    'Application Start',
    BaseCredentialApplicationReportFields.credentialApplicationStartDate,
    SearchValueType.Date
  ),
  ApplicationEndDateFilterModel: new RegularFilterModel(
    'Application End',
    BaseCredentialApplicationReportFields.credentialApplicationEndDate,
    SearchValueType.Date
  ),
  ApplicationStatusFilterModel: new RegularFilterModel(
    'Application Status',
    BaseCredentialApplicationReportFields.systemStatus,
    SearchValueType.List,
    ['InProgress', 'Completed', 'Archived']
  ),
  ApplicationStatusLabelModel: new RegularFilterModel(
    'Application Status Label',
    BaseCredentialApplicationReportFields.applicationStatusLabel,
    SearchValueType.MultiValue
  ),
  CredentialNameFilterModel: new RegularFilterModel(
    'Credential Name',
    BaseCredentialApplicationReportFields.credentialDefinitionId,
    SearchValueType.MultiValue
  ),
  RenewalApplicationStatusFilterModel: new RegularFilterModel(
    'Renewal Application Status',
    BaseCredentialApplicationReportFields.renewalApplicationStatus,
    SearchValueType.MultiValue
  ),
  ReinstateApplicationStatusFilterModel: new RegularFilterModel(
    'Reinstate Application Status',
    BaseCredentialApplicationReportFields.reinstateApplicationStatus,
    SearchValueType.MultiValue
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const PERSON_CREDENTIAL_APPLICATION_FILTER_MODELS = {
  ...BASE_CREDENTIAL_APPLICATION_FILTER_MODELS,
  FirstNameFilterModel: new RegularFilterModel(
    'First Name',
    PersonCredentialApplicationReportFields.firstName,
    SearchValueType.String
  ),
  LastNameFilterModel: new RegularFilterModel(
    'Last Name',
    PersonCredentialApplicationReportFields.lastName,
    SearchValueType.String
  ),
  EmailFilterModel: new RegularFilterModel(
    'Email',
    PersonCredentialApplicationReportFields.email,
    SearchValueType.Email
  ),

  SearchFilterModel: new SearchBoxFilterModel([
    { name: PersonCredentialApplicationReportFields.fullName, isGuid: false, isEmail: false },
    { name: PersonCredentialApplicationReportFields.email, isGuid: false, isEmail: true }
  ])
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const TEAM_CREDENTIAL_APPLICATION_FILTER_MODELS = {
  ...BASE_CREDENTIAL_APPLICATION_FILTER_MODELS,
  TeamNameFilterModel: new RegularFilterModel(
    'Team Name',
    TeamCredentialApplicationReportFields.teamName,
    SearchValueType.String
  ),
  TeamPublicNameFilterModel: new RegularFilterModel(
    'Team Public Name',
    TeamCredentialApplicationReportFields.teamPublicName,
    SearchValueType.String
  ),

  SearchFilterModel: new SearchBoxFilterModel([
    { name: TeamCredentialApplicationReportFields.teamName, isGuid: false, isEmail: false },
    { name: TeamCredentialApplicationReportFields.teamPublicName, isGuid: false, isEmail: false }
  ])
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const INPROGRESS_CREDENTIAL_APPLICATION_FILTER_MODELS = {
  ...BASE_CREDENTIAL_APPLICATION_FILTER_MODELS,
  NameFilterModel: new RegularFilterModel(
    'Name',
    InProgressEntityCredentialApplicationFields.name,
    SearchValueType.String
  ),
  EmailFilterModel: new RegularFilterModel(
    'Email',
    InProgressEntityCredentialApplicationFields.email,
    SearchValueType.Email
  ),
  CredentialTypeFilterModel: new RegularFilterModel(
    'Credential Type',
    InProgressEntityCredentialApplicationFields.entityType,
    SearchValueType.Boolean,
    []
  ),
  SearchFilterModel: new SearchBoxFilterModel([
    { name: InProgressEntityCredentialApplicationFields.name, isGuid: false, isEmail: false },
    { name: InProgressEntityCredentialApplicationFields.email, isGuid: false, isEmail: true }
  ])
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const CREDENTIALING_DETAILS_REPORT_FILTER_MODELS = {
  TeamNameFilterModel: new RegularFilterModel(
    'Team Name',
    CredentialingDetailsReportFields.teamName,
    SearchValueType.String
  ),
  TeamPublicNameFilterModel: new RegularFilterModel(
    'Team Public Name',
    CredentialingDetailsReportFields.teamPublicName,
    SearchValueType.String
  ),
  FirstNameFilterModel: new RegularFilterModel(
    'First Name',
    CredentialingDetailsReportFields.firstName,
    SearchValueType.String
  ),
  LastNameFilterModel: new RegularFilterModel(
    'Last Name',
    CredentialingDetailsReportFields.lastName,
    SearchValueType.String
  ),
  EmailFilterModel: new RegularFilterModel(
    'Email',
    CredentialingDetailsReportFields.email,
    SearchValueType.Email
  ),
  CredentialNameFilterModel: new RegularFilterModel(
    'Credential',
    CredentialingDetailsReportFields.credentialDefinitionId,
    SearchValueType.MultiValue
  ),
  CredentialNumberFilterModel: new RegularFilterModel(
    'Credential Number',
    CredentialingDetailsReportFields.credentialNumber,
    SearchValueType.String
  ),
  CredentialStatusLabelFilterModel: new RegularFilterModel(
    'Credential Status',
    CredentialingDetailsReportFields.credentialStatusLabel,
    SearchValueType.MultiValue
  ),
  IssueDateFilterModel: new RegularFilterModel(
    'Issue Date',
    CredentialingDetailsReportFields.issueDate,
    SearchValueType.Date
  ),
  ExpirationDateFilterModel: new RegularFilterModel(
    'Expiration Date',
    CredentialingDetailsReportFields.expirationDate,
    SearchValueType.Date
  ),
  LastApplicationStartDateFilterModel: new RegularFilterModel(
    'Last Application Start Date',
    CredentialingDetailsReportFields.lastApplicationStartDate,
    SearchValueType.Date
  ),
  TagFilterModel: new ChildFieldsFilterModel(
    CredentialingDetailsReportFields.tags,
    'Tag',
    CredentialTagFilterFields.text,
    SearchValueType.MultiValue
  ),
  SpecialtyFilterModel: new ChildFieldsFilterModel(
    CredentialingDetailsReportFields.specialties,
    'Specialty',
    'specialtyDefinitionId',
    SearchValueType.MultiValue
  ),
  SearchFilterModel: new SearchBoxFilterModel([
    { name: CredentialingDetailsReportFields.fullName, isGuid: false, isEmail: false },
    { name: CredentialingDetailsReportFields.email, isGuid: false, isEmail: true }
  ])
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const PERSON_CREDENTIALS_SUB_FILTER_MODELS = {
  IssueDateFilterModel: new SubConditionFilterModel(
    'Issue Date',
    CredentialingDetailsReportFields.issueDate,
    SearchValueType.Date
  ),
  ExpirationDateFilterModel: new SubConditionFilterModel(
    'Expiration Date',
    CredentialingDetailsReportFields.expirationDate,
    SearchValueType.Date
  ),
  CredentialStatusFilterModel: new SubConditionFilterModel(
    'Credential Status',
    CredentialingDetailsReportFields.systemStatus,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues(CredentialStatus.Active, 'Active'),
      new ODataFilterValues(CredentialStatus.ActiveRenewalPeriod, 'Active Renewal Period'),
      new ODataFilterValues(CredentialStatus.Inactive, 'Inactive'),
      new ODataFilterValues(CredentialStatus.InactiveRenewalPeriod, 'Inactive Renewal Period'),
      new ODataFilterValues(CredentialStatus.Manual, 'Manual')
    ]
  ),
  CredentialNumberFilterModel: new SubConditionFilterModel(
    'Credential Number',
    CredentialingDetailsReportFields.credentialNumber,
    SearchValueType.String
  ),
  CredentialSpecialtyFilterModel: new SubConditionFilterModel(
    'Specialty',
    CredentialingDetailsReportFields.specialties,
    SearchValueType.MultiValue
  )
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const OPPORTUNITY_BOARD_FILTER_MODELS = {
  OpportunityStartDateFilterModel: new RegularFilterModel(
    'Opportunity Start Date',
    OpportunityBoardFilterFields.opportunitySeatStartDate,
    SearchValueType.Date
  ),
  OpportunityEndDateFilterModel: new RegularFilterModel(
    'Opportunity End Date',
    OpportunityBoardFilterFields.opportunitySeatEndDate,
    SearchValueType.Date
  ),
  PositionNameFilterModel: new RegularFilterModel(
    'Position Name',
    OpportunityBoardFilterFields.positionName,
    SearchValueType.String
  ),
  TeamNameFilterModel: new RegularFilterModel(
    'Team Name',
    OpportunityBoardFilterFields.teamName,
    SearchValueType.String
  ),
  SearchFilterModel: new SearchBoxFilterModel([
    { name: OpportunityBoardFilterFields.positionName, isGuid: false, isEmail: false },
    { name: OpportunityBoardFilterFields.teamName, isGuid: false, isEmail: false }
  ])
};

//NOTE: IF YOU CHANGE ANY OF DISPLAY NAME HERE YOU HAVE TO ADD THIS CHANGE TO "name-changes-mapper.ts" FILE
export const PAYMENT_RECORDS_REPORT_FILTER_MODELS = {
  FirstNameFilterModel: new RegularFilterModel(
    'First Name',
    PaymentRecordsReportFields.firstName,
    SearchValueType.String
  ),
  LastNameFilterModel: new RegularFilterModel(
    'Last Name',
    PaymentRecordsReportFields.lastName,
    SearchValueType.String
  ),
  AmountFilterModel: new RegularFilterModel(
    'Amount',
    PaymentRecordsReportFields.amount,
    SearchValueType.Number
  ),
  OrderNumberFilterModel: new RegularFilterModel(
    'Order Number',
    PaymentRecordsReportFields.orderNumber,
    SearchValueType.String
  ),
  CompletionDateFilterModel: new RegularFilterModel(
    'Completion Date',
    PaymentRecordsReportFields.completionDate,
    SearchValueType.Date
  ),
  TransactionDateFilterModel: new RegularFilterModel(
    'Transaction Date',
    PaymentRecordsReportFields.transactionDate,
    SearchValueType.Date
  ),
  LedgerCodeFilterModel: new RegularFilterModel(
    'Ledger Code',
    PaymentRecordsReportFields.ledgerCode,
    SearchValueType.String
  ),
  LineItemDescriptionFilterModel: new RegularFilterModel(
    'Line Item Description',
    PaymentRecordsReportFields.lineItemDescription,
    SearchValueType.String
  ),
  PaymentTypeFilterModel: new RegularFilterModel(
    'Payment Type',
    PaymentRecordsReportFields.paymentType,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues('Card', 'Card'),
      new ODataFilterValues('Check', 'Check'),
      new ODataFilterValues('Ach', 'ACH')
    ]
  ),
  PaymentStatusFilterModel: new RegularFilterModel(
    'Payment Status',
    PaymentRecordsReportFields.invoiceStatus,
    SearchValueType.List,
    [InvoiceStatus.Open, InvoiceStatus.Paid, InvoiceStatus.Void, InvoiceStatus.OverDue]
  ),
  CredentialFilterModel: new RegularFilterModel(
    'Credential',
    PaymentRecordsReportFields.credentialDefinitionId,
    SearchValueType.MultiValue,
    []
  ),
  ApplicationTypeFilterModel: new RegularFilterModel(
    'Application Type',
    PaymentRecordsReportFields.credentialApplicationType,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues(CredentialApplicationDefinitionType.Initial, 'New Credential'),
      new ODataFilterValues(
        CredentialApplicationDefinitionType.Renewal,
        CredentialApplicationDefinitionType.Renewal
      ),
      new ODataFilterValues(
        CredentialApplicationDefinitionType.Reinstatement,
        CredentialApplicationDefinitionType.Reinstatement
      )
    ]
  ),
  ApplicationNumberFilterModel: new RegularFilterModel(
    'Application Number',
    PaymentRecordsReportFields.credentialApplicationNumber,
    SearchValueType.String
  ),
  SearchFilterModel: new SearchBoxFilterModel([
    { name: PaymentRecordsReportFields.fullName, isGuid: false, isEmail: false },
    { name: PaymentRecordsReportFields.ledgerCode, isGuid: false, isEmail: false },
    { name: PaymentRecordsReportFields.lineItemDescription, isGuid: false, isEmail: false }
  ])
};

export const PEOPLE_DEFAULT_QUICK_FILTERS: string[] = [
  PEOPLE_FILTER_MODELS.StatusFilterModel.displayName,
  PEOPLE_FILTER_MODELS.TagFilterModel.displayName,
  PEOPLE_FILTER_MODELS.PositionStatusFilterModel.displayName,
  PEOPLE_FILTER_MODELS.ActiveTeamsCountFilterModel.displayName,
  PEOPLE_FILTER_MODELS.AllTeamsCountFilterModel.displayName,
  PEOPLE_FILTER_MODELS.TeamExperienceFilterModel.displayName,
  PEOPLE_FILTER_MODELS.GenderFilterModel.displayName,
  PEOPLE_FILTER_MODELS.RaceFilterModel.displayName,
  PEOPLE_FILTER_MODELS.SubmittedApplicationFilterModel.displayName
];

export const OPPORTUNITY_BOARD_QUICK_FILTERS: string[] = [
  OPPORTUNITY_BOARD_FILTER_MODELS.OpportunityStartDateFilterModel.displayName,
  OPPORTUNITY_BOARD_FILTER_MODELS.OpportunityEndDateFilterModel.displayName,
  OPPORTUNITY_BOARD_FILTER_MODELS.PositionNameFilterModel.displayName,
  OPPORTUNITY_BOARD_FILTER_MODELS.TeamNameFilterModel.displayName
];

export const ALL_INVOICE_REPORT_FILTER_MODELS = {
  FirstNameFilterModel: new RegularFilterModel(
    'First Name',
    AllInvoiceReportFields.firstName,
    SearchValueType.String
  ),
  LastNameFilterModel: new RegularFilterModel(
    'Last Name',
    AllInvoiceReportFields.lastName,
    SearchValueType.String
  ),
  TotalAmountFilterModel: new RegularFilterModel(
    'Total Amount',
    AllInvoiceReportFields.totalAmount,
    SearchValueType.Number
  ),
  OrderNumberFilterModel: new RegularFilterModel(
    'Order Number',
    AllInvoiceReportFields.orderNumber,
    SearchValueType.String
  ),
  CompletionDateFilterModel: new RegularFilterModel(
    'Completion Date',
    AllInvoiceReportFields.completionDate,
    SearchValueType.Date
  ),
  TransactionDateFilterModel: new RegularFilterModel(
    'Transaction Date',
    AllInvoiceReportFields.transactionDate,
    SearchValueType.Date
  ),
  PaymentTypeFilterModel: new RegularFilterModel(
    'Payment Type',
    AllInvoiceReportFields.paymentType,
    SearchValueType.MultiValue,
    [
      new ODataFilterValues('Card', 'Card'),
      new ODataFilterValues('Check', 'Check'),
      new ODataFilterValues('Ach', 'ACH')
    ]
  ),
  PaymentStatusFilterModel: new RegularFilterModel(
    'Payment Status',
    AllInvoiceReportFields.paymentStatus,
    SearchValueType.List,
    [InvoiceStatus.Open, InvoiceStatus.Paid, InvoiceStatus.Void, InvoiceStatus.OverDue]
  ),
  SearchFilterModel: new SearchBoxFilterModel([
    { name: AllInvoiceReportFields.fullName, isGuid: false, isEmail: false },
    { name: AllInvoiceReportFields.checkNumber, isGuid: false, isEmail: false }
  ])
};
